<template>
  <div v-if="showSection">
    <div class="d-flex justify-content-center flex-column flex-md-row justify-content-md-start align-items-md-center" style="padding-bottom: inherit;min-heigth:30px;">

      <!-- Header title -->
      <h4 v-if="showTitle">{{$t('users.activities.title')}}</h4>

      <!-- Filter buttons -->
      <div class="d-flex justify-content-end search-text-wrapper pt-3 align-items-center" style="margin-left: auto;">
        <div class="d-flex align-self-center align-items-center">
          <Searchable
            :querySearch.sync="querySearch"
            :searchTooltip="{placement: 'left', content: this.$t('users.activities.search_tooltip')}"/>

            <Filters
              :isActive="showFilters"
              :activeFilters="activeFilters"
              @toggle-filters="showFilters = !showFilters"
            />
        </div>
      </div>

    </div>

    <!-- Component Content -->
    <div v-if="isLoading">
      <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
    <div v-else>
      <EntityActivityUserTable
        ref="entityActivityUsersTable"
        :user="user"
        :status="2"
        :show-filters="showFilters"
        @filters-updated="onFiltersUpdated"
        @edit="openEditUserActivityDate"
        @delete="openDeletingModal" />

      <va-button class="pull-right"
        @click.prevent="openEditUserActivityDate()">
        {{$t('users.new_activity')}}
      </va-button>
    </div>

    <EditUserActivityDateModal
      v-if="showEditUserActivityDate"
      :selected-activity="selectedActivity"
      :user="user"
      @created="onEntityActivityUserCreated"
      @updated="onEntityActivityUserUpdated"
      @modalClosed="onCloseEditUserActivityDate"
      @showBulkUpdateModal="onShowUserActivityBulkUpdate"/>

    <ConfirmationModal
      v-if="showDeletingModal"
      :title="$t('entities.activities.delete')"
      :body="$t('entities.activities.delete_message')"
      @modal-confirmed="destroyUserActivity"
      @modal-canceled="onCloseDeletingModal" />

    <ConfirmationModal
      v-if="showTransferAppointmentsModal && transferAppointmentsModalMessage !== null"
      :title="$t('entities.activities.transfer_appointments.generic_title')"
      :body="transferAppointmentsModalMessage"
      :cancelText="$t('entities.activities.transfer_appointments.do_not_transfer')"
      :okText="$t('entities.activities.transfer_appointments.generic_title')"
      @modal-confirmed="appointmentsTransfered"
      @modal-canceled="appointmentsTransferCancel" />

    <ConfirmUpdateBulkModal
      v-if="showUpdateEntityActivityUserModal"
      :isUpdating="isUpdating"
      :selectedActivity="selectedActivity"
      :updatingFormData="updatingFormData"
      :entityActivityUser="selectedActivity"
      @updated="onActivityUpdated"
      @modal-canceled="onCloseUpdatingModal" />


  </div>
</template>
<script>
import EntityActivityUserTable from '@/components/entity-activity-user/EntityActivityUserTable'
import LoadingAnimation from '../Helpers/LoadingAnimation'
import ViewActivitiesByEntity from './components/ViewActivitiesByEntity'
import ViewEntitiesByActivity from './components/ViewEntitiesByActivity'
import ScreenSizeMixin from '../Helpers/ScreenSizeMixin'
import Multiselect from 'vue-multiselect'
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import EditUserActivityDateModal from './EditUserActivityDateModal'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import ConfirmationModal from '@/components/common/ConfirmationModal'
import { EntityActivityUserService } from '@/api/AuthService'
import Errors from '@/utils/CustomNodeErrors.js'
import ConfirmUpdateBulkModal from '@/components/entity-activity-user/ConfirmUpdateBulkModal'
import EventBus from '@/utils/EventBus'
import {AppointmentService} from "@/api/AuthClinicalService";
import {mapGetters} from "vuex";
import {uniqBy} from "lodash";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
const errorsPrefix = 'entities.activities.errors.'

export default {
  components: {
    LoadingPlaceholder,
    Filters,
    Searchable,
    Multiselect,
    LoadingAnimation,
    ConfirmationModal,
    ConfirmUpdateBulkModal,
    ViewActivitiesByEntity,
    ViewEntitiesByActivity,
    EntityActivityUserTable,
    EditUserActivityDateModal,
  },
  mixins: [
    ScreenSizeMixin,
    TableQueryMixin
  ],
  props: {
    user: {
      type: Object,
      required: true
    },
    activities: {
      type: Array,
      required: true
    },
    availableActivities: {
      type: Array,
      required: false,
      default: () => []
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    limitItems: {
      type: Number,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    showSection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isSubmitting: false,
      querySearch: '',
      searchTooltip: { content: this.$t('users.activities.search_tooltip'), placement: 'top' },
      selectedActivity: null,
      showEditUserActivityDate: false,
      showDeletingModal: false,
      showUpdateEntityActivityUserModal: false,
      formErrors: new Errors(),
      showFilters: false,
      activeFilters: 0,
      isDeleting: false,
      isUpdating: false,
      updatingFormData: null,
      showTransferAppointmentsModal: false,
      transferAppointmentsModalMessage: null,
      appointmentsTransferable: null,
      entityActivityUserToTransfer: null,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
  },
  methods: {
    openEditUserActivityDate: function (entityActivityUser = null) {
      this.isUpdating = true
      this.showEditUserActivityDate = true
      this.selectedActivity = entityActivityUser
    },
    onCloseEditUserActivityDate: function () {
      this.isUpdating = false
      this.showEditUserActivityDate = false
      this.selectedActivity = null
    },
    openDeletingModal: function (activity) {
      this.showDeletingModal = true
      this.selectedActivity = activity
    },
    onCloseDeletingModal: function () {
      this.isDeleting = false
      this.showDeletingModal = false
      this.selectedActivity = null
      this.$refs.entityActivityUsersTable.reload()
    },
    onShowUserActivityBulkUpdate: function (data) {
      if (data) {
        this.updatingFormData = data.updatingFormData
      }
      this.openBulkUpdateEntityActivityUserModal()
    },
    onEntityActivityUserCreated: function ({ entityActivityUser }) {
      //if eau is for one day only, search appointments for that day
      this.isLoading = true
      if(entityActivityUser.end_date) {
        let start = this.moment(entityActivityUser.start_date)
        let end = this.moment(entityActivityUser.end_date)

        if(start.date() === end.date() && start.month() === end.month()) {
          const waitingRoomServices = this.services.filter(serv => this.$store.state.authClinicalServiceIds.some(id => id === serv.id))
          const authClinicalUrl = waitingRoomServices.filter(serv => serv.user_permissions.some(perm => perm.entity_id === entityActivityUser.entity_id))[0].url
          const params = {
            startDate: start.format('YYYY-MM-DD'),
            endDate: end.format('YYYY-MM-DD'),
            facilities: this.services.filter(serv => serv.url === this.$store.state.evollauth_server)[0].entities.filter(ent => ent.id === entityActivityUser.entity_id)[0].facilities.map(fac => fac.id).join(','),
            activities: entityActivityUser.activity_id,
            no_parent: true
          }
          AppointmentService.query(authClinicalUrl, params)
            .then(resp => {
              this.appointmentsTransferable = resp
              this.entityActivityUserToTransfer = entityActivityUser
              if(this.appointmentsTransferable.length > 0) {
                //gather all distinct dispensers
                const dispensers = this.appointmentsTransferable.map(app => app.user)
                const uniqueDispensers = uniqBy(dispensers, 'id')
                let strDispensers = ''

                for(let [index, disp] of uniqueDispensers.entries()) {

                  index === 0 ? strDispensers = strDispensers.concat(' '+disp.name) : strDispensers = strDispensers.concat(', '+disp.name)
                  if(disp.nickname) {
                    strDispensers = strDispensers.concat(` (${disp.nickname})`)
                  }
                }

                let dispenserTo = entityActivityUser.user.name
                if(entityActivityUser.user.nickname) {
                  dispenserTo = dispenserTo.concat(` (${entityActivityUser.user.nickname})`)
                }
                this.transferAppointmentsModalMessage = this.$t('entities.activities.transfer_appointments.generic_multiple', {count: this.appointmentsTransferable.length, dispenser_from: strDispensers, dispenser_to: dispenserTo})
                this.showTransferAppointmentsModal = true
              }
            })
            .catch(err => console.log(err))
          .finally(() => {
            this.finalizeEauCreated(entityActivityUser)
          })
        } else {
          this.finalizeEauCreated(entityActivityUser)
        }
      } else {
        this.finalizeEauCreated(entityActivityUser)
      }
    },
    finalizeEauCreated: function (entityActivityUser) {
      this.isLoading = false
      EventBus.$emit('ENTITY_ACTIVITY_USER_UPDATED', { entityActivityUser })
      this.showEditUserActivityDate = false
      this.selectedActivity = null
      this.$refs.entityActivityUsersTable.reload()
    },
    appointmentsTransfered: function () {
      //Transfer appointments
      let params = {}
      let appointmentIds = []
      this.appointmentsTransferable.forEach(elem => {
        appointmentIds.push(elem.id)
      })
      params.appointment_ids = appointmentIds
      params.entity_activity_user_id = this.entityActivityUserToTransfer.id
      AppointmentService.transferAppointments(this.$store.state.auth_clinical_server, params).then(transferredCount => {
        this.showToast(this.$t('entities.activities.transfer_appointments.success', {count: transferredCount}), this.$store.state.successToastOptions)
      }).catch(err => {
        this.showToast(this.$t('entities.activities.transfer_appointments.error'), this.$store.state.errorToastOptions)
        console.log(err)
      })
      //then
      this.appointmentsTransferable = null
      this.entityActivityUserToTransfer = null
      this.transferAppointmentsModalMessage = null
      this.showTransferAppointmentsModal = false
    },
    appointmentsTransferCancel: function () {
      this.appointmentsTransferable = null
      this.entityActivityUserToTransfer = null
      this.transferAppointmentsModalMessage = null
      this.showTransferAppointmentsModal = false
    },
    onEntityActivityUserUpdated: function ({ entityActivityUser }) {
      EventBus.$emit('ENTITY_ACTIVITY_USER_UPDATED', { entityActivityUser })
      this.isUpdating = false
      this.showEditUserActivityDate = false
      this.selectedActivity = null
      this.$refs.entityActivityUsersTable.reload()
    },
    destroyUserActivity: function () {
      this.isSubmitting = true
      this.isDeleting = true
      EntityActivityUserService.delete(this.selectedActivity.id)
        .then(response => {
          EventBus.$emit('ENTITY_ACTIVITY_USER_UPDATED', { entityActivityUser: this.selectedActivity })
          this.showToast(this.$t('entities.activities.deleted'), this.$store.state.successToastOptions)
          this.onCloseDeletingModal()
        }).catch(errors => {
          if (errors.response.status === 422) {
            this.formErrors.record(errors.response.data.errors, errorsPrefix)
            if (this.formErrors.has('entity_activity_user_id')) {
              this.openBulkUpdateEntityActivityUserModal()
            }
          } else {
            this.showToast(this.$t('entities.activities.delete_error'), this.$store.state.errorToastOptions)
          }
        }).finally(() => {
          this.isSubmitting = false
        })
    },
    openBulkUpdateEntityActivityUserModal: function () {
      this.showDeletingModal = false
      setTimeout(() => {
        this.showUpdateEntityActivityUserModal = true
      }, 250)
    },
    onCloseUpdatingModal: function () {
      this.showUpdateEntityActivityUserModal = false
      if (this.isDeleting) {
        setTimeout(() => {
          this.showDeletingModal = true
        }, 250)
      }
    },
    onActivityUpdated: function () {
      this.showUpdateEntityActivityUserModal = false
      this.showDeletingModal = false
      setTimeout(() => {
        this.showEditUserActivityDate = false
        this.isUpdating = false
      }, 250)
      setTimeout(() => {
        this.$refs.entityActivityUsersTable.reload()
      }, 1000)
    },
    onFiltersUpdated: function (nrFilters) {
      this.activeFilters = nrFilters
    }
  },
  watch: {
    querySearch: function (value) {
      this.$refs.entityActivityUsersTable.setTableFilter(value)
    }
  }
}
</script>

<style lang="scss">

#user-activities-table{
  .VueTables__search {
    display: none;
  }
}

.reset-filter{
  color: #C0C0C0;
  cursor: pointer;
  background-color: white;
}

.reset-search{
  color: #29c4a9;
  position: relative;
  margin-left: -25px;
}

.searchRoles {
  border-radius:20px;
  border-color: #A49D97;
  padding-left:10px;
  border-style: solid;
  padding-right: 18px;
  width: 225px;
  -webkit-transition: all .5s ease;
  -moz-transition: all .5s ease;
  transition: all .5s ease;
}

input.searchRoles{
    outline: none;
    border-color: #29c4a9;
}

.searchRoles::-webkit-outer-spin-button,
.searchRoles::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.search-text-wrapper{
  min-height: 35px;
}

.v-leave { opacity: 1; }
.v-leave-active { transition: opacity 250ms }
.v-leave-to { opacity: 0; }
.v-enter { opacity: 0; }
.v-enter-active  { transition: opacity 250ms }
.v-enter-to { opacity: 1; }

.search-roles-gone{
  cursor: default;
  visibility: none;
  opacity: 0;
  width: 0;
  animation-name: dissapearAnimation;
  animation-duration: 650ms;
}

@keyframes dissapearAnimation {
  0% {
    width: 225px;
  }
  100% {
    width: 0px;
    display: none;
  }
}

.multiselect .multiselect__tag {
    background-color: #29c4a9;
}
.multiselect .multiselect__option--highlight {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight::after {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--selected {
  background-color: #d9d9d9;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight {
  background-color: #e34a4a;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #e34a4a;
}

@keyframes spin {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(180deg);}
}

.modal{
  overflow: auto;
}

.vuestic-tabs .tab-content {
  padding-top: 1rem;
}
</style>
